/**
 * UIDs masqués par snooze overlay (Gmail local) — le sync ne doit pas
 * les traiter comme des arrivées (sinon journal « Préparation ×N » + blocage).
 */
const hiddenByFolder = new Map<string, Set<number>>();

function folderKey(accountId: number, folder: string): string {
  return `${accountId}\0${folder}`;
}

export function setActiveSnoozeHiddenUids(
  accountId: number,
  entries: Array<{ folder: string; uid: number; holdFolder?: string | null }>
): void {
  if (accountId < 1) return;

  for (const key of [...hiddenByFolder.keys()]) {
    if (key.startsWith(`${accountId}\0`)) {
      hiddenByFolder.delete(key);
    }
  }

  for (const entry of entries) {
    if (entry.uid < 1) continue;
    // Overlay local uniquement — hold IMAP = vraiment déplacé, pas « faux nouveau ».
    if (entry.holdFolder?.trim()) continue;
    const folder = entry.folder.trim() || "INBOX";
    const key = folderKey(accountId, folder);
    let set = hiddenByFolder.get(key);
    if (!set) {
      set = new Set();
      hiddenByFolder.set(key, set);
    }
    set.add(entry.uid);
  }
}

export function filterOutActiveSnoozeHiddenUids(
  accountId: number,
  folder: string,
  uids: number[]
): number[] {
  if (uids.length === 0) return uids;
  const set = hiddenByFolder.get(folderKey(accountId, folder));
  if (!set || set.size === 0) return uids;
  return uids.filter((uid) => !set.has(uid));
}

export function isActiveSnoozeHiddenUid(
  accountId: number,
  folder: string,
  uid: number
): boolean {
  if (uid < 1) return false;
  return hiddenByFolder.get(folderKey(accountId, folder))?.has(uid) === true;
}
